import {AfterViewInit, Component, OnInit} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {PasswordModule} from "primeng/password";
import {CheckboxModule} from "primeng/checkbox";
import {Ripple} from "primeng/ripple";
import {  ButtonModule} from "primeng/button";
import {AuthService} from "../../core/service/auth/Auth.service";
import {ToastModule} from 'primeng/toast';
import {ImageModule} from "primeng/image";
import {StyleClassModule} from "primeng/styleclass";
import {InputTextModule} from "primeng/inputtext";
import {MessageService} from "primeng/api";
import {ActivatedRoute, Route, Router} from "@angular/router";
import {Location, NgIf} from "@angular/common";
import {ProgressSpinner} from "primeng/progressspinner";
import {finalize} from "rxjs";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-login',
    standalone: true,
  imports: [
    FormsModule,
    PasswordModule,
    CheckboxModule,
    Ripple,
    ToastModule,
    ButtonModule,
    ImageModule,
    StyleClassModule,
    InputTextModule,
    NgIf,
    ProgressSpinner,
    TranslatePipe,
  ],
    templateUrl: './login.component.html',
    styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit, AfterViewInit {

    public username = "";
    public password = "";
    errorMessage: any = { severity: 'error', summary: '', detail: '', sticky: true };
    loggedIn: boolean = false;
    public rememberMe: boolean = false;
    loading: any;

    // Set in ngOnInit, consumed in ngAfterViewInit — the <p-toast/> child only subscribes
    // to MessageService in its own ngOnInit, which runs after this component's ngOnInit,
    // so show() must wait until the view (and its toast) is ready or the message is dropped.
    private showServerUnreachableMessage = false;

    constructor(
      private authService: AuthService,
      private messageService: MessageService,
      private router: Router,
      private route: ActivatedRoute,
      private translate: TranslateService,
      private location: Location
    ) {
    }

    ngOnInit(): void {
      if (this.route.snapshot.queryParams['reason'] === 'server-unreachable') {
        this.errorMessage.summary = this.translate.instant('http.serverUnreachableSummary');
        this.errorMessage.detail = this.translate.instant('http.serverUnreachableDetail');
        this.showServerUnreachableMessage = true;
        // Strip the query param via the History API directly — a router.navigate() here
        // would re-run route resolution just to edit the address bar.
        this.location.replaceState(this.location.path().split('?')[0]);
      }
    }

    ngAfterViewInit(): void {
      if (this.showServerUnreachableMessage) this.show();
    }

  public login() {
    this.loading = true;
    this.errorMessage.summary = this.translate.instant('login.loginFailTitle');

    this.authService.login(
      this.username,
      this.password,
      this.rememberMe
    ).pipe(
      finalize(() => this.loading = false)
    ).subscribe({
      next: (result) => {
        if (result.isSuccess) {
          this.router.navigate(['/'])
        } else {
          this.errorMessage.detail = result.errorMessage ?? this.translate.instant('login.loginFailMessage');
        this.show()
        console.error('is success false : ' , result);
        }
      },
      error: (err) => {
        this.errorMessage.summary = this.translate.instant('login.unexpectedError');
        this.errorMessage.detail = err?.error?.errorMessage?.message ?? this.translate.instant('login.loginFailMessage');
        this.show()
        console.error('Login failed:', err);

      }
    });
  }

  show() {

    this.messageService.add(this.errorMessage);
  }

  clear() {
    this.messageService.clear();
  }
}
